import { useEffect, useMemo, useState } from 'react'
import { Alert, Box, Stack, Typography } from '@mui/material'
import { Chars, generateToken } from '@basementscripts/token-generator'
import { createArray, Logger, Field } from '@wolfdanepug/common-react'
import { dogState } from '../context/onboarding/state'
import { SegmentComponentProps } from '../types'
import { DOG, DOGS, MAX_DOGS_THRESHOLD, NAME_IS, NAMES_ARE } from '../context/onboarding/options'

const thresholdErrorMessage = `You can add up to ${MAX_DOGS_THRESHOLD - 1} dogs, during this onboarding process. You can add more after in your Member Dashboard after you sign up or, contact help@wolfdanepug.com for further assistance.`

export default function Intro({ data, state, setCanStepForward }: SegmentComponentProps) {
	// the dog names
	const [dogNames, setDogNames] = useState<string[]>(data?.dogs || [])
	// the number of dogs
	const [numDogs, setNumDogs] = useState<number | undefined>(data?.totalDogs || undefined)
	// the dogs
	const [dogs, setDogs] = useState<any[]>(data?.dogs || [])
	const [thresholdError, setThresholdError] = useState<boolean>(false)

	useEffect(() => {
		if (data) {
			Logger.log('Intro data', data)
			setNumDogs(data.totalDogs)
			if (data.dogs) {
				setDogNames(data.dogs)
				setDogs(data.dogs.map((name: string) => data.dog[name]))
			}
		}
	}, [data])

	useEffect(() => {
		Logger.log('Intro dogs', dogs)
	}, [dogs])

	useEffect(() => {
		Logger.log('Intro dogNames', dogNames)
	}, [dogNames])

	useEffect(() => {
		Logger.log('Intro dogs', numDogs)
	}, [numDogs])

	/**
	 * Update Dogs
	 * @param {number} total
	 * @returns {void}
	 */
	const updateDogs = (total: number): void => {
		if (total > dogs.length) {
			const arr = createArray(total - dogs.length).map(() => ({
				...dogState,
				key: generateToken({ type: Chars.AlphaNumeric, length: 16 })
			}))
			setDogs([...dogs, ...arr])
		} else if (total < dogs.length) {
			setDogs(dogs.slice(0, total))
		}
	}

	/**
	 * Handle Number of Dogs Change
	 * @param {Event} event
	 * @returns {void}
	 */
	const handleNumDogsChange = ({ target }: any): void => {
		const value = target.value

		setNumDogs(value)

		if ((value && value <= MAX_DOGS_THRESHOLD - 1) || undefined) {
			updateDogs(value)
			setThresholdError(false)
			// update({ numberOfDogs: value, dogs })
		} else if (value && value > MAX_DOGS_THRESHOLD - 1) {
			Logger.log('Too many dogs!')
			setThresholdError(true)
		}
		const valid = dogNames.filter((name) => name.length > 2)
		!state.canStepForward && valid.length === value && setCanStepForward(true)
		state.canStepForward && valid.length < value && setCanStepForward(false)
	}

	/**
	 * Handle Dog Name Change
	 * @param {Event} event
	 * @param {number} index
	 * @returns {void}
	 */
	const handleDogNameChange = ({ target }: any, index: number): void => {
		const dogsState = [...dogNames]
		dogsState[index] = target.value

		setDogNames(dogsState)
		if (!numDogs) return
		const valid = dogsState.filter((name) => name.length > 2)

		!state.canStepForward && valid.length === +numDogs && setCanStepForward(true)
		state.canStepForward && valid.length < +numDogs && setCanStepForward(false)
	}

	const numberOfDogsContext = useMemo(() => {
		return numDogs && numDogs > 1 ? DOGS : DOG
	}, [numDogs])

	const dogNamePluralityContext = useMemo(() => {
		const nameContext = numDogs && numDogs > 1 ? NAMES_ARE : NAME_IS
		return `Their ${nameContext}`
	}, [numDogs])

	return (
		<>
			<Stack alignItems="center" gap={3}>
				{thresholdError && <Alert severity="error">{thresholdErrorMessage}</Alert>}
				<Stack direction="row" alignItems="center" gap={2}>
					<Typography sx={{ whiteSpace: 'nowrap' }}>I have</Typography>
					<Field
						required
						name="numberOfDogs"
						type="number"
						// label="Number of dogs"
						defaultValue={numDogs}
						onChange={handleNumDogsChange}
						variant="standard"
						InputProps={{ inputProps: { min: 0, max: MAX_DOGS_THRESHOLD } }}
						sx={{ field: { width: 100, '& input': { textAlign: 'center' } } }}
					/>
					<Typography>{numberOfDogsContext}</Typography>
				</Stack>

				{dogs?.length > 0 && (
					<Stack
						direction="row"
						sx={{
							// direction: { xs: 'column', sm: 'row' },
							alignItems: 'center',
							justifyContent: 'center',
							gap: 2,
							flexWrap: 'wrap'
						}}
					>
						<Typography sx={{ whiteSpace: 'nowrap' }}>{dogNamePluralityContext}</Typography>

						{dogs?.map((dog: any, idx: number) => {
							return (
								<Box component="span" key={dog.key}>
									<Field
										required
										name={['name', 'dogs', idx]}
										variant="standard"
										defaultValue={dog.name || dogNames[idx] || ''}
										sx={{ field: { '& input': { textAlign: 'center' } } }}
										onChange={(e: any) => handleDogNameChange(e, idx)}
									/>
									<Field type="hidden" name={['key', 'dogs', idx]} value={dog.key} />
								</Box>
							)
						})}
					</Stack>
				)}
			</Stack>
			<input type="hidden" name="selected__dog" value={0} />
		</>
	)
}
